import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import GoalStaticsContainer from '../../containers/goal_statics/GoalStaticsContainer';

const GoalStaticsViewPage = () => {
  return (
    <div>
      <BreadcrumbsContainer title="목표관리/영업목표통계" icon="goal" />
      <GoalStaticsContainer />
    </div>
  );
};

export default GoalStaticsViewPage;
